import { take } from 'rxjs/operators';

import { Directive, ElementRef, HostListener } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ScrollService } from '@core/services/scroll/scroll.service';

@UntilDestroy()
@Directive({
    selector: '[appHandleInvalidOnSubmit]',
    standalone: true
})
export class HandleInvalidOnSubmitDirective {
    constructor(
        private form: ElementRef,
        private formGroupDirective: FormGroupDirective,
        private scrollService: ScrollService
    ) {}

    @HostListener('ngSubmit') onSubmit(): void {
        this.formGroupDirective.control.markAllAsTouched();
        if (!this.formGroupDirective.control.valid) {
            this.scrollToFirstInvalidControl();
        }
    }

    private scrollToFirstInvalidControl(): void {
        const firstInvalidElement: HTMLElement | null = this.form.nativeElement.querySelector('.ng-invalid');
        if (!firstInvalidElement) {
            return;
        }
        this.scrollService
            .scrollTo(firstInvalidElement, { ignoreIfVisible: true })
            .pipe(untilDestroyed(this), take(1))
            .subscribe(() => {
                firstInvalidElement.focus();
            });
    }
}
